import ReactDOMServer from 'react-dom/server'
import Download from './download'

// var tableToExcel = (function() {
//     var uri = 'data:application/vnd.ms-excel;base64,',
//             template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">'
//                              + '<head><meta http-equiv="Content-type" content="text/html;charset=UTF-8" /><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>'
//                              + '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
//             base64 = function(s) {
//                 return window.btoa(unescape(encodeURIComponent(s)))
//             },
//             format = function(s, c) {
//                 return s.replace(/{(\w+)}/g, function(m, p) {
//                     return c[p];
//                 })
//             };
 
//     return function(html, name) {
//         var ctx = {
//             worksheet : name || 'Worksheet',
//             table : html
//         }
//         return uri + base64(format(template, ctx));
//     }
// })();


export default function toXlsx(html, filename = '') {
    var preHtml = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="Content-type" content="text/html;charset=UTF-8" /><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Corpus Results</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
    var postHtml = "</body></html>";
    var excelHtml = preHtml + html + postHtml;

    // let excel = tableToExcel(html, worksheet)

    var blob = new Blob(['\ufeff', excelHtml], {
        type: 'application/vnd.ms-excel'
    });

    filename = filename || 'results.xls';
    Download(blob, filename)
}